module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/toc#ab2",
      "id": "ba2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I thank J. Clint Sprott, Leon Cohen, Dennis Gordon, Nick Hobson, Teja Krašek, Pete Barnes, and Paul Moskowitz for their comments and suggestions. I would also like to especially acknowledge Melanie Madden, my editor for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While researching the milestones and pivotal moments in this book, I studied a wide array of wonderful reference works and Web sites, many of which are listed in the “Notes and Further Reading” section at the end of this book. These references include Joanne Baker’s "), _c('i', [_vm._v("50 Physics Ideas You Really Need to Know")]), _vm._v(", James Trefil’s "), _c('i', [_vm._v("The Nature of Science")]), _vm._v(", and "), _c('i', [_vm._v("Peter Tallack’s The Science Book")]), _vm._v(". On-line sources such as Wikipedia ("), _c('a', {
    attrs: {
      "href": "http://wikipedia.org",
      "target": "_blank"
    }
  }, [_vm._v("wikipedia.org")]), _vm._v(") are a valuable starting point for readers and can be used as a launch-pad to more information.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I should also point out that some of my own previous books, such as "), _c('i', [_vm._v("Archimedes to Hawking: Laws of Science and the Great Minds Behind Them")]), _vm._v(", provided background information for some of the entries dealing with physical laws, and the reader is urged to consult this book for additional information.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d4930c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 81
// module chunks = 0